import React, { createContext, useContext } from 'react';

import { MultipleAccountsSelectionProps } from '../../components/MultipleAccountsSelection/types';
import { CustomerDetailFullAccount } from '../../store/customerDetail/types';

export interface CustomerDetailContextData {
  isLoading: boolean;
  hasError: boolean;
  onRefresh: () => void;
  customer: CustomerDetailFullAccount | null | undefined;
  accountSelected?: MultipleAccountsSelectionProps['accountSelected'];
  handleChangeAccount?: MultipleAccountsSelectionProps['setAccountSelected'];
}

interface Props extends CustomerDetailContextData {
  children: React.ReactElement;
}

const CustomerDetailContext = createContext<CustomerDetailContextData>(
  {} as CustomerDetailContextData
);

export const CustomerDetailProvider: React.FC<Props> = ({ children, ...value }) => {
  return <CustomerDetailContext.Provider value={value}>{children}</CustomerDetailContext.Provider>;
};

export const useCustomerDetailContext = (): CustomerDetailContextData => {
  const context = useContext(CustomerDetailContext);

  if (!context) {
    throw new Error('useCustomerDetailContext must be used within an CustomerDetailProvider');
  }

  return context;
};
